import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { TabsPage } from '../pages/tabs/tabs';
import { HomePage } from '../pages/home/home'
import { LoginPage } from '../pages/login/login'
import { AngularFireAuth } from 'angularfire2/auth';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage : any = TabsPage;

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, afAuth: AngularFireAuth) {

    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
      let self = this;
      const authObserver = afAuth.authState.subscribe( user => {
        if (user) {
          // console.log('wel user', user)
          self.rootPage = TabsPage;
        } else {
          // console.log('niet user')
          self.rootPage = LoginPage;
        }
      });
    });

  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts